'use strict';

var _toConsumableArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var sortedMap = require('../utils/sorted-map.js');

var DefaultTaskMerger = {
  hasNewInfo: function hasNewInfo() {
    return false;
  },
  merge: function merge() {}
};

var RequestQueue = /*#__PURE__*/function () {
  function RequestQueue() {
    var taskMerger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DefaultTaskMerger;

    _classCallCheck(this, RequestQueue);

    this._taskMerger = taskMerger;
    this._byPeer = new sortedMap.SortedMap([], PeerTasks.compare);
  }

  _createClass(RequestQueue, [{
    key: "pushTasks",
    value: function pushTasks(peerId, tasks) {
      var peerTasks = this._byPeer.get(peerId.toB58String());

      if (!peerTasks) {
        peerTasks = new PeerTasks(peerId, this._taskMerger);
      }

      peerTasks.pushTasks(tasks);

      this._byPeer.set(peerId.toB58String(), peerTasks);
    }
  }, {
    key: "popTasks",
    value: function popTasks(targetMinBytes) {
      var peerTasks = this._head();

      if (peerTasks === undefined) {
        return {
          tasks: [],
          pendingSize: 0
        };
      }

      var _peerTasks$popTasks = peerTasks.popTasks(targetMinBytes),
          tasks = _peerTasks$popTasks.tasks,
          pendingSize = _peerTasks$popTasks.pendingSize;

      if (tasks.length === 0) {
        return {
          tasks: tasks,
          pendingSize: pendingSize
        };
      }

      var peerId = peerTasks.peerId;

      if (peerTasks.isIdle()) {
        this._byPeer.delete(peerId.toB58String());
      } else {
        this._byPeer.update(0);
      }

      return {
        peerId: peerId,
        tasks: tasks,
        pendingSize: pendingSize
      };
    }
  }, {
    key: "_head",
    value: function _head() {
      if (this._byPeer.size === 0) {
        return undefined;
      }

      var _iterator = _createForOfIteratorHelper(this._byPeer),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              v = _step$value[1];

          return v;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return undefined;
    }
  }, {
    key: "remove",
    value: function remove(topic, peerId) {
      var peerTasks = this._byPeer.get(peerId.toB58String());

      peerTasks && peerTasks.remove(topic);
    }
  }, {
    key: "tasksDone",
    value: function tasksDone(peerId, tasks) {
      var peerTasks = this._byPeer.get(peerId.toB58String());

      if (!peerTasks) {
        return;
      }

      var i = this._byPeer.indexOf(peerId.toB58String());

      var _iterator2 = _createForOfIteratorHelper(tasks),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var task = _step2.value;
          peerTasks.taskDone(task);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      this._byPeer.update(i);
    }
  }]);

  return RequestQueue;
}();

var PeerTasks = /*#__PURE__*/function () {
  function PeerTasks(peerId, taskMerger) {
    _classCallCheck(this, PeerTasks);

    this.peerId = peerId;
    this._taskMerger = taskMerger;
    this._activeTotalSize = 0;
    this._pending = new PendingTasks();
    this._active = new Set();
  }

  _createClass(PeerTasks, [{
    key: "pushTasks",
    value: function pushTasks(tasks) {
      var _iterator3 = _createForOfIteratorHelper(tasks),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var t = _step3.value;

          this._pushTask(t);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "_pushTask",
    value: function _pushTask(task) {
      if (!this._taskHasMoreInfoThanActiveTasks(task)) {
        return;
      }

      var existingTask = this._pending.get(task.topic);

      if (existingTask) {
        if (task.priority > existingTask.priority) {
          this._pending.updatePriority(task.topic, task.priority);
        }

        this._taskMerger.merge(task, existingTask);

        return;
      }

      this._pending.add(task);
    }
  }, {
    key: "_taskHasMoreInfoThanActiveTasks",
    value: function _taskHasMoreInfoThanActiveTasks(task) {
      var tasksWithTopic = [];

      var _iterator4 = _createForOfIteratorHelper(this._active),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var activeTask = _step4.value;

          if (activeTask.topic === task.topic) {
            tasksWithTopic.push(activeTask);
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      if (tasksWithTopic.length === 0) {
        return true;
      }

      return this._taskMerger.hasNewInfo(task, tasksWithTopic);
    }
  }, {
    key: "popTasks",
    value: function popTasks(targetMinBytes) {
      var size = 0;
      var tasks = [];

      var pendingTasks = this._pending.tasks();

      for (var i = 0; i < pendingTasks.length && size < targetMinBytes; i++) {
        var task = pendingTasks[i];
        tasks.push(task);
        size += task.size;

        this._pending.delete(task.topic);

        this._activeTotalSize += task.size;

        this._active.add(task);
      }

      return {
        tasks: tasks,
        pendingSize: this._pending.totalSize
      };
    }
  }, {
    key: "taskDone",
    value: function taskDone(task) {
      if (this._active.has(task)) {
        this._activeTotalSize -= task.size;

        this._active.delete(task);
      }
    }
  }, {
    key: "remove",
    value: function remove(topic) {
      this._pending.delete(topic);
    }
  }, {
    key: "isIdle",
    value: function isIdle() {
      return this._pending.length === 0 && this._active.size === 0;
    }
  }], [{
    key: "compare",
    value: function compare(a, b) {
      if (a[1]._pending.length === 0) {
        return 1;
      }

      if (b[1]._pending.length === 0) {
        return -1;
      }

      if (a[1]._activeTotalSize === b[1]._activeTotalSize) {
        return b[1]._pending.length - a[1]._pending.length;
      }

      return a[1]._activeTotalSize - b[1]._activeTotalSize;
    }
  }]);

  return PeerTasks;
}();

var PendingTasks = /*#__PURE__*/function () {
  function PendingTasks() {
    _classCallCheck(this, PendingTasks);

    this._tasks = new sortedMap.SortedMap([], this._compare);
  }

  _createClass(PendingTasks, [{
    key: "length",
    get: function get() {
      return this._tasks.size;
    }
  }, {
    key: "totalSize",
    get: function get() {
      return _toConsumableArray(this._tasks.values()).reduce(function (a, t) {
        return a + t.task.size;
      }, 0);
    }
  }, {
    key: "get",
    value: function get(topic) {
      return (this._tasks.get(topic) || {}).task;
    }
  }, {
    key: "add",
    value: function add(task) {
      this._tasks.set(task.topic, {
        created: Date.now(),
        task: task
      });
    }
  }, {
    key: "delete",
    value: function _delete(topic) {
      this._tasks.delete(topic);
    }
  }, {
    key: "tasks",
    value: function tasks() {
      return _toConsumableArray(this._tasks.values()).map(function (i) {
        return i.task;
      });
    }
  }, {
    key: "updatePriority",
    value: function updatePriority(topic, priority) {
      var obj = this._tasks.get(topic);

      if (!obj) {
        return;
      }

      var i = this._tasks.indexOf(topic);

      obj.task.priority = priority;

      this._tasks.update(i);
    }
  }, {
    key: "_compare",
    value: function _compare(a, b) {
      if (a[1].task.priority === b[1].task.priority) {
        return a[1].created - b[1].created;
      }

      return b[1].task.priority - a[1].task.priority;
    }
  }]);

  return PendingTasks;
}();

exports.RequestQueue = RequestQueue;